import {
	Box,
	styled,
	Typography as TypographyMui,
	TypographyProps as TypographyPropsMui,
} from '@mui/material';
import * as React from 'react';

type TypographyProps = TypographyPropsMui & {
	label: string;
	value: string;
	children?: React.ReactNode;
	notBold?: boolean;
};

const LabelTypography = styled(TypographyMui)({});
const ValueTypography = styled(TypographyMui)({});

const TypographyBox = styled(Box)({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'flex-start',
});

const CompositeTypography: React.FC<TypographyProps> = props => {
	const { notBold, ...otherProps } = props;
	return (
		<TypographyBox {...otherProps}>
			<LabelTypography
				variant={'body'}
				{...otherProps}
				sx={{ paddingRight: props.children ? '8px' : '0px', whiteSpace: 'nowrap' }}
			>
				{`${props.label}:`}
			</LabelTypography>
			{props.children ? (
				props.children
			) : props.notBold ? (
				<LabelTypography sx={{ ml: 1 }} variant={'body'}>
					{props.value}
				</LabelTypography>
			) : (
				<ValueTypography sx={{ ml: 1 }} variant={'bodyLink'}>
					{props.value}
				</ValueTypography>
			)}
		</TypographyBox>
	);
};

export default CompositeTypography;
